import React, { Component } from 'react';
import { Form, Input, Col, Row, message, Empty } from 'antd';
import DetailTitle from '../../../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../../../components/Custom';
import { config, postFrom } from '../../../../../../axios';
import moment from 'moment';
import { moneyAddComma } from '../../../../../../utils/index';
import { checkOutType, backMoneyType } from '../../../../../../axios/dictionaries'
import "../index.less"

class RetreatMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            InputWidth: "185px",
            shortInputWidth: "135px",
            current: 1,
            tableData: [{ name: '常规押金', bill: "2018-04-23 至 2018-05-22", money: "1500.00", remark: "测试说明" }],
            tableLoading: false,
            tableTotal: '',
            data: {},
            collection: 0,
            refund: 0

        }
    }

    componentDidMount() {
        this.loadUserMsg();
    }

    loadUserMsg = () => { //退租信息详情

        this.setState({ loading: true });
        postFrom(
            {
                url: config.API_rentcontract_getRentContractByIdEndMsg,
                data: {
                    rentContractId: this.props.id,
                }
            }
        ).then(res => {
            this.setState({ loading: false, data: res });
        }).catch(err => {
            // message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    calculate = (arr, key) => {
        let total = arr.reduce((prev, curv) => {
            prev instanceof Object ? prev = prev[key] : prev;
            return prev + curv[key]
        })
        return total
    }

    render() {
        let { form: { getFieldDecorator } } = this.props;
        let {
            data,
        } = this.state;

        let collection = Array.isArray(data.receiveType) && data.receiveType.length ? data.receiveType.reduce((total, item) => total + item.endAmount, 0) : 0;
        let refound = Array.isArray(data.paidType) && data.paidType.length ? data.paidType.reduce((total, item) => total + item.endAmount, 0) : 0;
        let endTypes = data instanceof Object ? checkOutType.find(item => data.endType === item.value) : null
        let endPayTypes = data instanceof Object ? backMoneyType.find(item => data.endPayType === item.value) : null

        return (
            <div>
                <div className="custom" style={{ paddingBottom: "20px" }}>
                    {
                        data instanceof Object && Object.keys(data).length !== 0 ?
                            <Form
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                            >
                                <CustomRow title="结算">
                                    <CustomCol label="退租日" required={false} >
                                        {getFieldDecorator('factEndDate', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.factEndDate ? moment(data.factEndDate).format("YYYY-MM-DD") : null
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="退租类型" required={false} >
                                        {getFieldDecorator('endType', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: endTypes ? endTypes.title : null
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider title={true}>
                                    <div style={{ flex: 1 }} className="tableBox">
                                        <div className="tableTitle">
                                            <div style={{ flex: 1 }}>退款类别</div>
                                            <div style={{ flex: 1 }}>账单周期</div>
                                            <div style={{ flex: 1 }}>应退金额（元）</div>
                                            <div style={{ flex: 1 }}>说明</div>
                                        </div>
                                        <div className="tableBody">
                                            {
                                                Array.isArray(data.paidType) ?
                                                    data.paidType.map(item => {
                                                        return (
                                                            <div className="tableBodyRow" key={item.id} style={{ height: '34px' }}>
                                                                <div style={{ flex: 1 }}>{item.feeName}</div>
                                                                <div style={{ flex: 1 }}>{
                                                                    `${moment(item.billBeginDate).format("YYYY-MM-DD")} 至 ${moment(item.billEndDate).format("YYYY-MM-DD")} `
                                                                }</div>
                                                                <div style={{ flex: 1 }}>
                                                                    {moneyAddComma(item.endAmount)}
                                                                </div>
                                                                <div style={{ flex: 1 }}>{
                                                                    item.feeRemark
                                                                }</div>
                                                            </div>
                                                        )
                                                    })
                                                    : null
                                            }
                                            <label className="tableBodyRow" style={{ height: '34px' }}>
                                                <div style={{ paddingLeft: "15px", textAlign: 'left' }}>退款：<span style={{ color: "red" }}>
                                                    {moneyAddComma(refound)}
                                                </span>元</div>
                                            </label>
                                        </div>
                                    </div>

                                </CustomRow>
                                <CustomRow divider title={true}>
                                    <div style={{ flex: 1 }} className="tableBox">
                                        <div className="tableTitle">
                                            <div style={{ flex: 1 }}>收款类别</div>
                                            <div style={{ flex: 1 }}>账单周期</div>
                                            <div style={{ flex: 1 }}>应收金额（元）</div>
                                            <div style={{ flex: 1 }}>说明</div>
                                        </div>
                                        <div className="tableBody">
                                            {
                                                Array.isArray(data.receiveType) ?
                                                    data.receiveType.map(item => {
                                                        return (
                                                            <label className="tableBodyRow" key={item.id}>
                                                                <div style={{ flex: 1 }}>{item.feeName}</div>
                                                                <div style={{ flex: 1 }}>{
                                                                    `${moment(item.billBeginDate).format("YYYY-MM-DD")} 至 ${moment(item.billEndDate).format("YYYY-MM-DD")} `
                                                                }</div>
                                                                <div style={{ flex: 1 }}>
                                                                    {moneyAddComma(item.endAmount)}
                                                                </div>
                                                                <div style={{ flex: 1 }}>{item.feeRemark}</div>
                                                            </label>
                                                        )
                                                    })
                                                    : null
                                            }
                                            <label className="tableBodyRow" style={{ height: '34px' }}>
                                                <div style={{ paddingLeft: "15px", textAlign: 'left' }}>收款：<span style={{ color: "red" }}>
                                                    {moneyAddComma(collection)}
                                                </span>元</div>
                                            </label>
                                        </div>
                                    </div>
                                </CustomRow>
                                <CustomRow divider title={true}>
                                    <div>
                                        {data.endAmount>0 ?'应收合计':'应退合计'}：<span style={{ color: "red", fontSize: "20px" }}>
                                            {moneyAddComma(data.endAmount)}
                                        </span>元
                                </div>
                                </CustomRow>
                                <CustomRow divider title={true}>
                                    <CustomCol label="应退方式" required={false} >
                                        {getFieldDecorator('faceDetected', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: endPayTypes ? endPayTypes.title : null
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="账号信息" required={false} >
                                        {getFieldDecorator('endPayAccount', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.endPayAccount
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            // style={{ width: "614px" }}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>

                                <div style={{
                                    display: "none"
                                }}>
                                    <CustomRow>
                                        <CustomCol label="收款方式" required={false} >
                                            {getFieldDecorator('faceDetected', {
                                                rules: [{
                                                    required: false, message: '请输入',
                                                }],
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                    disabled={true}
                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                </div>
                                <div className="hr"></div>
                                <CustomRow divider title="办理">
                                    <CustomCol label="办理部门" required={false} >
                                        {getFieldDecorator('faceDetected', {
                                            rules: [{
                                                required: false, message: '请输入',

                                            }],
                                            initialValue: data.merchantDepartmentName
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="办理人" required={false} >
                                        {getFieldDecorator('faceDetected', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.merchantUserName
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="办理日期" required={false} >
                                        {getFieldDecorator('faceDetected', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.endHandleDate ? moment(data.endHandleDate).format("YYYY-MM-DD") : null
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider title={true}>
                                    <CustomCol label="办理备注" required={false} colStyle={{ width: '800px' }}>
                                        {getFieldDecorator('endHandleRemark', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.endHandleRemark
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            </Form> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }

                </div>
            </div>
        )
    }
}

export default Form.create()(RetreatMessage)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/RetreatMessage/index.js